import type { AccountMeetingLocationModel } from './account.type.ts';
import type {
  ConfirmationStatusEnum,
  ConfirmationStatusModel,
} from './confirmation-status.model.ts';
import type { CalendarEvent } from './event.type.ts';
import type { MeetingListModel } from './meeting.type.ts';
import type { StaffMemberListModel } from './staff-member.type.ts';

export interface AvailabilitySlotModel extends CalendarEvent {
  createdAt: string;
  officeNotes?: string;
  staffMemberAvailabilities: StaffMemberAvailabilityModel[];
  accountMeetingLocation?: AccountMeetingLocationModel;
  localStart: string;
  localEnd: string;
}

export interface AvailabilitySlotPostModel {
  accountId: number;
  start: string;
  end: string;
  officeNotes: string;
  accountMeetingLocationId: number;
  accountRepresentativeIds: number[];
  accountCategoryIds: number[];
  staffMemberAvailabilities: { [staffMemberId: number]: ConfirmationStatusEnum };
  recurringOptions?: RecurringOptions;
}

export interface AvailabilitySlotPutModel {
  start: string;
  end: string;
  officeNotes: string;
  accountMeetingLocationId: number;
  accountRepresentativeIds: number[];
  accountCategoryIds: number[];
  staffMemberAvailabilities: { [staffMemberId: number]: ConfirmationStatusEnum };
}

export interface RecurringOptions {
  timeZone: string;
  frequency: RecurringFrequencyEnum;
  endDate: string;

  /**
   * undefined if every weekday
   * */
  recurEvery?: number;

  /**
   * daily
   * */
  everyWeekday?: boolean;

  /**
   * weekly: every {RecurEvery} weeks on {DaysOfWeek}
   * */
  daysOfWeek?: string[];

  /**
   * monthly: every {DateOfMonth} of every {RecurEvery} month
   * */
  dateOfMonth?: number;

  /**
   * monthly: on the {WeekOfMonth} {DayOfWeek} every {RecurEvery} month
   * */
  weekOfMonth?: WeekOfMonthEnum;

  /**
   * monthly: on the {WeekOfMonth} {DayOfWeek} every {RecurEvery} month
   * */
  dayOfWeek?: string;
}

export interface AvailabilitySlotListModel {
  id: number;
  key: string;
  start: string;
  end: string;
  officeNotes?: string;
  accountMeetingLocation?: AccountMeetingLocationModel;
  accountId: number;
  accountKey: string;
  accountName: string;
  staffMemberAvailabilities: StaffMemberAvailabilityModel[];
  meetings: MeetingListModel[];
}

export enum RecurringFrequencyEnum {
  Day = 1,
  Week = 2,
  Month = 3,
}

export enum WeekOfMonthEnum {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Last = 5,
}

export interface StaffMemberAvailabilityModel {
  staffMember: StaffMemberListModel;
  availabilitySlotId: number;
  confirmationStatus: ConfirmationStatusModel;
}
